const googleAPIKey = "AIzaSyCCh-2w0Pmh2mElKvgeyhb4TQJ6Ophh8gs";
const maxFileSize = 30000000;

module.exports = {
    googleAPIKey,
    maxFileSize
};